import React from 'react'

const FriendsPage = () => {
    return (
        <div>
            Freinds
        </div>
    )
}

export default FriendsPage
